// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { ShipmentDataUpload } from '@/shipment/components/shipment-data-upload';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export function ShipmentDataImportDialog(props: Props) {
  return (
    <Dialog fullWidth maxWidth="md" open={props.isOpen} onClose={props.onClose}>
      <DialogTitle>Upload shipment data</DialogTitle>
      <DialogContent dividers>
        <ShipmentDataUpload onClose={props.onClose} />
      </DialogContent>
    </Dialog>
  );
}
